var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Col',{attrs:{"span":20,"offset":2}},[_c('Tabs',{attrs:{"value":"upload"}},[_c('TabPane',{attrs:{"label":"上传","name":"upload"}},[_c('upload')],1),_c('TabPane',{attrs:{"label":"访视","name":"visit"}},[_c('visit')],1),_c('TabPane',{attrs:{"label":"表单","name":"domain"}},[_c('domain')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }